import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import PasswordResetForm from "../../components/sentry/PasswordResetForm.jsx";
import UserDetailsRequestFormResult from "../../components/sentry/UserDetailsRequestFormResult.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import { passwordReset } from "../../state/reducers/account/accountActions.js";
import { resetErrors } from "../../state/reducers/api/apiActions.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class PasswordRecovery extends Component {
  static propTypes = {
    isFetching: PropTypes.bool,
    isSuccess: PropTypes.bool,
    passwordReset: PropTypes.func.isRequired,
    resetErrors: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "sentry.password_reset"
  };

  constructor(props) {
    super(props);

    const { token } = props.match.params;

    this.state = {
      token
    };
  }

  // -- HANDLERS -- //

  onReset = () => {
    this.props.resetErrors();
  };

  onSubmit = values => {
    const { token } = this.state;
    const data = {
      token: token,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation
    };
    this.props.passwordReset(data);
  };

  // -- RENDER -- //

  renderForm = () => {
    const { isFetching, isSuccess } = this.props;

    if (isSuccess) {
      return (
        <UserDetailsRequestFormResult
          copyKey={"sentry.password_reset_result"}
        />
      );
    }

    return (
      <PasswordResetForm
        isFetching={isFetching}
        onReset={this.onReset}
        onSubmit={this.onSubmit}
      />
    );
  };

  render() {
    const { copyKey, copy } = this.props;

    return (
      <div className="sentry-form">
        <Header as="h3" inverted>
          {copy(`${copyKey}.title`)}
        </Header>
        <Segment padded textAlign="left">
          {this.renderForm()}
        </Segment>
        <footer>
          <LinkWithReset to="/">{copy(`${copyKey}.login_cta`)}</LinkWithReset>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.password.isFetching,
  isSuccess: state.password.isSuccess,
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  passwordReset: data => dispatch(passwordReset(data)),
  resetErrors: () => dispatch(resetErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordRecovery);
